<template>
<div class="chapter">
<div class="inner_page">
<p class="fmh">Contents</p>
<p class="cct"><span href="#/xhtml/title#tit" title="Link target outside of Sample">Title Page</span></p>
<p class="cct"><span href="#/xhtml/copyrightnotice#notice" title="Link target outside of Sample">Copyright Notice</span></p>
<p class="cct"><a href="#/xhtml/dedication#ded">Dedication</a></p>
<p class="cct-bot"><a href="#/xhtml/epigraph#epig">Epigraph</a></p>
<p class="cct"><a href="#/xhtml/chapter1#ch1">1 Perfect</a></p>
<p class="cct"><a href="#/xhtml/chapter2#ch2">2 Cards on the Tracks</a></p>
<p class="cct"><span href="#/xhtml/chapter3#ch3" title="Link target outside of Sample">3 Pleasant Hill</span></p>
<p class="cct"><span href="#/xhtml/chapter4#ch4" title="Link target outside of Sample">4 With It</span></p>
<p class="cct"><span href="#/xhtml/chapter5#ch5" title="Link target outside of Sample">5 Midnight</span></p>
<p class="cct"><span href="#/xhtml/chapter6#ch6" title="Link target outside of Sample">6 Single-o</span></p>
<p class="cct"><span href="#/xhtml/chapter7#ch7" title="Link target outside of Sample">7 The Best I’ve Met in Years</span></p>
<p class="cct"><span href="#/xhtml/chapter8#ch8" title="Link target outside of Sample">8 Dice Man</span></p>
<p class="cct"><span href="#/xhtml/chapter9#ch9" title="Link target outside of Sample">9 And a Little Child Shall Lead Them</span></p>
<p class="cct"><span href="#/xhtml/chapter10#ch10" title="Link target outside of Sample">10 The Gambler’s Rose</span></p>
<p class="cct-bot"><span href="#/xhtml/chapter11#ch11" title="Link target outside of Sample">11 One Card</span></p>
<p class="cbmh"><span href="#/xhtml/note#note" title="Link target outside of Sample">Notes</span></p>
<p class="cbmh"><span href="#/xhtml/bibliography#bib" title="Link target outside of Sample">Bibliography</span></p>
<p class="cbmh"><span href="#/xhtml/acknowledgments#ack" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="cbmh"><span href="#/xhtml/index#index" title="Link target outside of Sample">Index</span></p>
<p class="cbmh"><span href="#/xhtml/aboutauthor#about" title="Link target outside of Sample">About the Author</span></p>
<p class="cbmh"><span href="#/xhtml/Copyright#crt" title="Link target outside of Sample">Copyright</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?db9dd9a4